// extracted by mini-css-extract-plugin
module.exports = {"link":"Styles_link__j7LT_"};